export const NAVIGATION_ENTRY = 'navigation';
export const RESOURCE_ENTRY = 'resource';



// WEBPACK FOOTER //
// ../../../../src/instrumentations/performance/performanceConstants.ts